import React, { ChangeEvent, FC, memo, useCallback, useMemo } from 'react';
import './OilSelect.scss';
import { useTranslation } from 'react-i18next';

interface OilSelectProps {
  label: string;
  placeholder: string;
  options: string[];
  value: string | null;
  onChange: (newValue: string) => void;
}

const OilSelect: FC<OilSelectProps> = ({
  label,
  placeholder,
  options,
  value,
  onChange,
}) => {
  const selectClassName = useMemo(
    () => `OilSelect__select ${!value ? 'OilSelect__select--placeholder' : ''}`,
    [value]
  );

  const handleSelectChange = useCallback(
    ({ target: { value: newValue } }: ChangeEvent<HTMLSelectElement>) => {
      onChange(newValue.length > 0 ? newValue : null);
    },
    [onChange]
  );
  const { t } = useTranslation();

  return (
    <div className="OilSelect">
      <label>{label}</label>

      <select
        className={selectClassName}
        placeholder={placeholder}
        value={value ?? ''}
        onChange={handleSelectChange}
      >
        {!value ? (
          <option value="" disabled>
            {placeholder}
          </option>
        ) : (
          <option value="">--- {t('Reset filter')} ---</option>
        )}

        {options.map((opt, key) => (
          <option {...{ key }} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    </div>
  );
};

export default memo(OilSelect);
